export default "__VITE_ASSET__BjuKyfxH__"